module.exports = __webpack_public_path__ + "static/media/vf_mjacket_core.715ffc24.svg";